<template>
    <div class="footer-box">
            <div class="ewm-box">
                <img src="./../assets/img/ewm.png" alt="">
                <p>小蜜蜂智慧消防</p>
            </div>
            <div class="foot-right">
                <p>
                    <img src="./../assets/img/call.png" alt="">
                    <span>4000-690-119</span>
                </p>
                <p>
                    <img src="./../assets/img/location.png" alt="">
                    <span>北京市西城区西直门外大街1号西环广场T2号楼19C5  </span>
                </p>
            </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss">
    .footer-box{
        padding:.2rem;
        background:#F8F8F7;
        color: #333;
        font-size: .2rem;
        @extend .flex;
        .ewm-box{
            img{
                width:1.2rem;
                margin-bottom:.1rem;
                // display: block;
                
            }
            text-align: center;
            
        }
        .foot-right{
            padding-left:.1rem;
            padding-top:.1rem;
            img{
                margin-right: .1rem;
                width:.3rem;
            }
            p{
                line-height: 1;
                @extend .flex;
                align-items: center;
            }
            p:first-child{
                margin-bottom:.4rem;
            }
        }
    }
</style>
